import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const ASSIGN_DRAW_MAP_TASK = gql`
  mutation AssignIndoorMapDrawTask($input: AssignIndoorMapDrawTaskInput!) {
    assignIndoorMapDrawTask(input: $input) {
      indoorMapDrawTask {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
